import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Card, CardBody, CardFooter } from 'components/card';
import { Button, ButtonsGroup } from 'components/button';
import { ROUTE_LOGIN } from 'routes/RouteList';
import messages from 'messages';
import {
  CardHeader,
  CardHeaderTitle,
  CardHeaderSubtitle
} from 'components/card/card-header';
import FieldInput from 'components/input/FieldInput';
import { StoreContext } from 'index';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import Icon from 'components/icon/Icon';

const TotpForm = () => {
  const { authStore } = useContext(StoreContext);
  const { push } = useHistory();
  const [errorMessage, setErrorMessage] = useState('');

  const onSubmitHandler = async ({ totpCode }) => {
    const result = await authStore.doLoginWithTotpCode(totpCode);
    if (result?.error) {
      setErrorMessage(result.error.message);
    }
  };

  const handleCancel = e => {
    e.preventDefault();

    push(ROUTE_LOGIN);
  };

  const validationSchema = Yup.object().shape({
    totpCode: Yup.string().required()
  });

  return (
    <Card extraClassNames="c-card--primary">
      <CardHeader primary>
        <Button
          tiny
          extraClassNames="c-button--absolute-top-left c-button--large-spacing"
          onClick={e => handleCancel(e)}
        >
          <Icon id="back-nav" mediumIcon />
        </Button>
        <CardHeaderTitle>
          <FormattedMessage {...messages.totpFormTitle} />
        </CardHeaderTitle>
        <CardHeaderSubtitle extraClassNames="u-margin-horizontal-auto">
          <FormattedMessage {...messages.totpFormSubtitle} />
        </CardHeaderSubtitle>
      </CardHeader>
      <Formik
        initialValues={{ totpCode: '' }}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={onSubmitHandler}
      >
        {({ touched, errors, isValid, dirty }) => {
          return (
            <Form noValidate>
              <CardBody primary>
                <FieldInput
                  id="totpCode"
                  name="totpCode"
                  type="text"
                  errors={errors}
                  touched={touched}
                >
                  <FormattedMessage {...messages.totpFormCodeLabel} />
                </FieldInput>
              </CardBody>
              <CardFooter primary>
                <ButtonsGroup>
                  <Button secondary onClick={e => handleCancel(e)}>
                    <FormattedMessage {...messages.loginCancelButton} />
                  </Button>
                  <Button primary type="submit" disabled={!(isValid && dirty)}>
                    <FormattedMessage {...messages.totpFormSubmitButton} />
                  </Button>
                </ButtonsGroup>
              </CardFooter>
            </Form>
          );
        }}
      </Formik>
    </Card>
  );
};

export default TotpForm;
